import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../auth_services/useAuth';
// material
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// icons-material
import RoofingIcon from '@mui/icons-material/Roofing';
import PieChartIcon from '@mui/icons-material/PieChart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import CampaignIcon from '@mui/icons-material/Campaign';

import ViewModule from '@mui/icons-material/ViewModule';
import Settings from '@mui/icons-material/Settings';
import WatchLater from '@mui/icons-material/WatchLater';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ReorderIcon from '@mui/icons-material/Reorder';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import merchant_empty from "../../../picture/merchant_empty.png";
import thana_logo from "../../../picture/logo/thana_logo.png";

import { axiosPrivateStatic } from '../../../api/axios';

const ListItemStyle = (menuStatus) => {
    return ({
        color: 'text.leftmenu',
        '&.MuiListItemButton-root': {
            //padding: '5px 0px 3px 22px',
        },
        '&.css-10hburv-MuiTypography-root:hover': {
            fontWeight: '700'
        },
        '.css-p15rgm-MuiTypography-root': {
            fontWeight: 'none'
        },

        /**
         * ListItemText selected font bold
         */
        '&.Mui-selected .css-10hburv-MuiTypography-root': {
            fontWeight: '700'
        },
        '&.MuiListItem-root:hover .css-10hburv-MuiTypography-root': {
            color: '#ffffff'
        },

        /**
         * Icon selected set color ffffff
         */
        '&.Mui-selected .css-i4bv87-MuiSvgIcon-root': {
            color: '#ffffff'
        }
    })
};

const ListSubheaderStyle = {
    fontWeight: '500',
    fontSize: '12px',
    paddingTop: '8px',
    paddingBottom: '8px',
    marginLeft: '14px',
    color: 'text.highlight',
    '&.MuiListSubheader-root': {
        lineHeight: '10px',
        backgroundColor: 'background.leftmenu'
    },
    '@media screen and (max-width: 1400px)': {
        //display: 'none',
    }
};

const ListItemIconStyle = {
    minWidth: '35px',
    pl: '8px'
    //color: 'text.leftmenu',
};

const imgPosition = {
    pl: '8px'
}

const leftReszieHide = {
    '@media screen and (max-width: 1400px)': {
        //display: 'none',
    }
}

const subMenuStyle = {
    //marginLeft: '30px',
    paddingLeft: '65px'
}

const IconSize = (menuStatus) => {
    return ({
        fontSize: '22px',
    })
};


const miniSubMenuIcon = {
    ml: -1.8,
    mt: 1
}

const menuIconAndText = {
    ml: '-10px'
}

const iconAndText = {
    ml: '10px'
}

const Leftmenu = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuActive, setMenuActive] = useState('');
    const [open, setOpen] = useState({
        report: false,
        product: false,
        user: false,
        setting: false
    });

    useEffect(() => {
        if (props.menuActive != undefined) {
            //console.log('True');
            setMenuActive(props.menuActive);

            if (
                props.menuActive == '/dashboard' ||
                props.menuActive == '/sale' ||
                props.menuActive == '/bill' ||
                props.menuActive == '/customer' ||
                props.menuActive == '/settings/merchant_info' ||
                props.menuActive == '/package/view'
            ) {
                setOpen({
                    report: false,
                    product: false,
                    user: false,
                    setting: false
                })
            } else {
                setOpen({
                    report: props.mainMenuActive?.includes('report') ? true : false,
                    product: props.mainMenuActive?.includes('product') ? true : false,
                    user: props.mainMenuActive?.includes('user') ? true : false,
                    setting: props.mainMenuActive?.includes('setting') ? true : false,
                })
            }
        }

    }, [props.menuActive, props.drawerStatus]);

    const setMaxVal = (val) => {
        if (val >= 1000) {
            return '999+';
        } else {
            return val
        }
    }

    useEffect(() => {
        getProfileImage();
    }, [location.pathname, props.merchantVal]);
    // Image path
    const [imgPath, setImgPath] = useState('');
    const getProfileImage = async () => {
        if (useAuth.GetToken() != null && props.merchantVal?.logo != undefined && props.merchantVal?.logo != '') {
            await axiosPrivateStatic.get(`merchant_info/image/${props.merchantVal.logo}`, {
                responseType: "arraybuffer"
            }).then((res) => {
                const base64 = btoa(
                    new Uint8Array(res.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ''
                    )
                )
                //Set image for showing in src
                setImgPath(base64);
            }).catch((err) => setImgPath(''));
        } else {
            setImgPath('');
        }
    }

    /**
     * Handle sale customer screen
     */
    useEffect(() => {

        window.addEventListener("storage", onStorageUpdate);
        return () => {
            window.removeEventListener("storage", onStorageUpdate);
        };
    }, []);

    const [smallLeftMenu, setSmallLeftMenu] = useState(false);
    const onStorageUpdate = (e) => {
        const { key, newValue } = e;
        // Order item
        if (key === "mm") {
            //console.log('Lister...123');
            setSmallLeftMenu(newValue);
        }
    };

    // Dashboard
    const dashboard = [
        {
            'permission': useAuth.checkPermission('db', 'v'),
            'link_name': 'Dashboard',
            'path': '/dashboard',
            'icon': <RoofingIcon sx={IconSize(props.menuStatus)} />
        }
    ];

    // Sale
    const sale = [
        { 'link_name': 'ຂາຍສິນຄ້າ', 'path': '/sale', 'icon': <ShoppingCartIcon sx={IconSize(props.menuStatus)} /> },
        { 'link_name': 'ໃບບິນ', 'path': '/bill', 'icon': <ReceiptLongIcon sx={IconSize(props.menuStatus)} /> },
    ];

    // Report
    const report = [
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'sl'), 'link_name': 'ລາຍງານ-ລາຍຮັບ-ລາຍຈ່າຍ', 'path': '/income_expense/report', 'icon': <AssessmentIcon sx={IconSize(props.menuStatus)} /> },
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'sl'), 'link_name': 'ລາຍງານ-ການຂາຍ(ຕາມບິນ)', 'path': '/sale/report', 'icon': <ReceiptLongIcon sx={IconSize(props.menuStatus)} /> },
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'prdsl'), 'link_name': 'ລາຍງານ-ສິນຄ້າຂາຍອອກ', 'path': '/product/sale/report', 'icon': <ShoppingCartCheckoutIcon sx={IconSize(props.menuStatus)} /> },
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'stin'), 'link_name': 'ລາຍງານ-ສິນຄ້າຊື້ເຂົ້າ', 'path': '/product/buy/report', 'icon': <AddShoppingCartIcon sx={IconSize(props.menuStatus)} /> },
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'st'), 'link_name': 'ລາຍງານ-ສິນຄ້າໃນສາງ', 'path': '/product/stock/report', 'icon': <ViewModule sx={IconSize(props.menuStatus)} /> },
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'ofst'), 'link_name': 'ລາຍງານ-ສິນຄ້າໝົດສາງ', 'path': '/product/outofstock/report', 'icon': <ProductionQuantityLimitsIcon sx={IconSize(props.menuStatus)} /> },
        { 'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']), 'permission': useAuth.checkPermission('rp', 'exp'), 'link_name': 'ລາຍງານ-ສິນຄ້າໝົດອາຍຸ', 'path': '/product/expire/report', 'icon': <WatchLater sx={IconSize(props.menuStatus)} /> }
    ];

    // Product
    const product = [
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'link_name': 'ຂໍ້ມູນສິນຄ້າ',
            'path': '/product',
            'icon': <ListAltIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'link_name': 'ສິນຄ້າເຂົ້າສາງ',
            'path': '/product/stock/in',
            'icon': <AddShoppingCartIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'link_name': 'ສິນຄ້າໄກ້ຈະໝົດສາງ',
            'path': '/product/outofstock/soon',
            'icon': <ProductionQuantityLimitsIcon sx={IconSize(props.menuStatus)} />,
            'countNotify': setMaxVal(props.prdOutofStockCount), 'chip': <Chip label={setMaxVal(props.prdOutofStockCount)} size='small' color='error' sx={{ minWidth: '20px' }} />
        },
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'link_name': 'ສິນຄ້າໄກ້ຈະໝົດອາຍຸ',
            'path': '/product/stock/expire',
            'icon': <WatchLater sx={IconSize(props.menuStatus)} />,
            'countNotify': setMaxVal(props.prdExpireSoonCount),
            'chip': <Chip label={setMaxVal(props.prdExpireSoonCount)} size='small' color='error' />
        },
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'link_name': 'ຂໍ້ມູນກຸ່ມ, ປະເພດ, ຫົວໜ່ວຍ',
            'path': '/product/group',
            'icon': <ReorderIcon sx={IconSize(props.menuStatus)} />
        }
    ];

    // Customer
    const customer = [
        {
            'package': useAuth.package([['PK00', 'PK01', 'PK02', 'PK03']]),
            'link_name': 'ຂໍ້ມູນລູກຄ້າ',
            'path': '/customer',
            'icon': <PeopleAltIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'package': useAuth.package([['PK00', 'PK01', 'PK02', 'PK03']]),
            'link_name': 'ຈັດໂປໂມຊັ່ນ',
            'path': '/promotion',
            'icon': <CampaignIcon sx={IconSize(props.menuStatus)} />
        },
    ];

    // General setting
    const GeneralSetting = [
        /*{
            'link_name': 'ໂປໂມຊັ່ນ', 'path': '/promotion', 'icon': <img
                src={promotionIcon}
                alt=""
                loading="lazy"
                style={ImgSize(props.menuStatus)}
            />
        },*/
        {
            'link_name': 'ຕັ້ງຄ່າ', 'path': '/settings/merchant_info', 'icon': <Settings sx={IconSize(props.menuStatus)} />
        },
        {
            'link_name': 'ແພັກແກັດ', 'path': '/package/view', 'icon': <CardGiftcardIcon sx={IconSize(props.menuStatus)} />
        },
    ];

    // User group menu
    const User = [
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'role': 'all',
            'link_name': 'ຂໍ້ມູນສ່ວນຕົວ',
            'lng': 'profile',
            'path': '/profile',
            'icon': <AccountCircleIcon sx={IconSize(props.menuStatus)} />
        },
        {
            'package': useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']),
            'role': useAuth.role(),
            'link_name': 'ຂໍ້ມູນຜູ້ໃຊ້ລະບົບ',
            'lng': 'user',
            'path': '/user',
            'icon': <PeopleAltIcon sx={IconSize(props.menuStatus)} />
        },
    ];

    const PackageName = (pk) => {
        if (pk == 'PK00') {
            return 'Free 14ວັນ'
        } else if (pk == 'PK01') {
            return 'Basic'
        } else if (pk == 'PK02') {
            return 'Smart'
        } else if (pk == 'PK03') {
            return 'Pro'
        }
    }

    const [anchorEl, setAnchorEl] = useState(null);
    const openMiniMenu = Boolean(anchorEl);
    const [miniMenu, setMiniMenu] = useState([]);
    const handleClick = (event, menuVal) => {
        if (menuVal == 'report') {
            setMiniMenu(report);
        } else if (menuVal == 'product') {
            setMiniMenu(product);
        } else if (menuVal == 'user') {
            setMiniMenu(User);
        } else if (menuVal == 'setting') {
            setMiniMenu(GeneralSetting);
        }
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const Menumini = (
        <>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMiniMenu}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: -0.1,
                            ml: 0.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 26,
                                left: -5,
                                right: 0,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                {
                    miniMenu.map((text, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                navigate(text.path);
                                handleClose();
                            }}
                        >
                            <ListItemIcon>
                                {text.icon}
                            </ListItemIcon>
                            {text.link_name}
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    );

    return (
        <>
            {Menumini}
            <Box position="fixed" sx={{ zIndex: 1, width: (props.menuStatus == 'large') ? '250px' : '80px' }}>
                <Box
                    sx={{
                        marginLeft: '0px',
                        marginTop: '0px',
                        backgroundColor: 'background.leftmenu',
                        padding: '15px 0px 0px 5px',
                        color: 'text.fixed',
                        fontSize: '33px',
                        fontWeight: '800'
                    }}
                >
                    <Box sx={{ color: 'text.fixed', paddingLeft: '15px' }}>
                        <img style={{ width: '100px' }} alt="" src={thana_logo} />
                    </Box>
                </Box>
                <Box
                    sx={{
                        paddingLeft: '0px',
                        backgroundColor: 'background.leftmenu',
                        //display: { xs: 'none', md: 'flex' },
                        justifyContent: 'center',
                        borderStyle: 'solid',
                        borderWidth: '0px 0px 1px 0px',
                        borderColor: 'boderColor.default',
                        cursor: 'pointer',
                        height: '60px'
                    }}
                    onClick={() => navigate('/settings/merchant_info')}
                >
                    <ListItem sx={{ marginTop: '0px' }} onClick={props.setOnMenuClose}>
                        <ListItemAvatar >
                            <Tooltip title='ຂໍ້ມູນຮ້ານຄ້າ'>
                                {imgPath != 'imgnull' ? (
                                    <Avatar
                                        alt=""
                                        src={`data:;base64,${imgPath}`}
                                        sx={{ marginTop: '5px', width: 40, height: 40 }}
                                        className='cursor-pointer'
                                    />
                                ) : (
                                    <img className="profile-image" alt="" src={merchant_empty} style={{ marginTop: '5px', width: 40, height: 40 }} />
                                )}
                            </Tooltip>
                        </ListItemAvatar>
                        {props.menuStatus == 'large' &&
                            <ListItemText
                                primary={
                                    <Box sx={{ marginLeft: '-10px' }}>
                                        <Box>
                                            <Typography noWrap sx={{ fontSize: '14px' }}>
                                                {props.merchantVal.merchant_name}
                                            </Typography>
                                        </Box>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontSize: '10px',
                                            fontWeight: '600',
                                            color: props.merchantVal.pk == 'PK00' ? 'red' : ''
                                        }}>
                                            <CardGiftcardIcon sx={{ color: 'text.fixed', fontSize: '15px' }} />
                                            {props.merchantVal.unlimit == 'Y' ? (
                                                <Box sx={{ color: 'text.fixed' }}>Package unlimit</Box>
                                            ) : (
                                                <Box>
                                                    &nbsp;{PackageName(props.merchantVal.pk)}
                                                    &nbsp;{props.merchantVal.pk != 'PK00' ? `1${props.merchantVal.pkpayment}` : ''}
                                                    &nbsp;{props.merchantVal.pkexdayscount <= 1 ? `ໝົດອາຍຸເເລ້ວ` : `(${props.merchantVal.pkexdayscount} ວັນ)`}
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                }
                            />
                        }
                    </ListItem>
                </Box>
            </Box >
            <Box sx={{ marginTop: '124px', zIndex: 0 }}>
                {/*** Dashboard */}
                {useAuth.checkPermission('db', 'v') &&
                    <>
                        {
                            dashboard.map((text, index) => (
                                <ListItemButton
                                    sx={ListItemStyle(props.menuStatus)}
                                    key={text.link_name}
                                    component={NavLink}
                                    to={text.path}
                                    target={(text.path == '/sale/customer/screen') ? '_blank' : ''}
                                    selected={location.pathname === text.path || menuActive === text.path}
                                    onClick={props.setOnMenuClose}
                                >
                                    <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                        <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                    </Tooltip>
                                    <ListItemText sx={iconAndText}>
                                        {(() => {
                                            if (props.menuStatus != 'small') {
                                                return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                            } else {
                                                return (<>&nbsp;</>)
                                            }
                                        })()}
                                    </ListItemText>
                                </ListItemButton>
                            ))
                        }
                    </>
                }

                {/*** Sale */}
                {(useAuth.role() == 'admin' || useAuth.role() == 'user') &&
                    <>
                        {/*<Box sx={ListSubheaderStyle}>ຂາຍສິນຄ້າ</Box>*/}
                        {
                            sale.map((text, index) => (
                                <ListItemButton
                                    sx={ListItemStyle(props.menuStatus)}
                                    key={text.link_name}
                                    component={NavLink}
                                    to={text.path}
                                    onClick={props.setOnMenuClose}
                                    selected={location.pathname === text.path || menuActive === text.path}
                                >
                                    <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                        <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                    </Tooltip>
                                    <ListItemText sx={iconAndText}>
                                        {(() => {
                                            if (props.menuStatus != 'small') {
                                                return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                            } else {
                                                return (<>&nbsp;</>)
                                            }
                                        })()}

                                    </ListItemText>
                                </ListItemButton>
                            ))
                        }
                    </ >
                }

                {/*** Report ************************* */}
                {
                    (
                        (useAuth.role() == 'admin' || useAuth.role() == 'user')
                        && (
                            useAuth.checkPermission('rp', 'sl')
                            || useAuth.checkPermission('rp', 'prdsl')
                            || useAuth.checkPermission('rp', 'stin')
                            || useAuth.checkPermission('rp', 'st')
                            || useAuth.checkPermission('rp', 'ofst')
                            || useAuth.checkPermission('rp', 'exp')
                        )
                    ) &&
                    <>
                        <ListItemButton
                            sx={{ height: '55px' }}
                            selected={props.menuStatus == 'small' && props.mainMenuActive === 'report'}
                            onClick={(e) => {
                                setOpen({ report: !open.report });
                                if (props.menuStatus == 'small') {
                                    handleClick(e, 'report');
                                }
                            }}
                        >
                            <ListItemIcon sx={imgPosition}>
                                <PieChartIcon sx={IconSize(props.menuStatus)} />
                            </ListItemIcon>
                            <ListItemText primary={props.menuStatus != 'small' ? "ລາຍງານ" : ""} sx={menuIconAndText} />
                            {props.menuStatus != 'small' ? open.report ? <ExpandLess /> : <ExpandMore /> : ''}
                            {props.menuStatus == 'small' ? <ArrowDropDownIcon sx={miniSubMenuIcon} /> : ''}
                        </ListItemButton>
                        {props.menuStatus != 'small' &&
                            <Collapse in={open.report} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {
                                        report.map((text, index) => (
                                            (text.package && text.permission == true) &&
                                            <ListItemButton
                                                sx={subMenuStyle}
                                                key={text.link_name}
                                                component={NavLink}
                                                to={text.path}
                                                onClick={props.setOnMenuClose}
                                                selected={location.pathname === text.path || menuActive === text.path}
                                            >
                                                {/*
                                                <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                                    <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                                </Tooltip>
                                                */}
                                                <ListItemText sx={leftReszieHide}>
                                                    {(() => {
                                                        if (props.menuStatus != 'small') {
                                                            return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                                        } else {
                                                            return (<>&nbsp;</>)
                                                        }
                                                    })()}
                                                </ListItemText>
                                            </ListItemButton>
                                        ))
                                    }
                                </List >
                            </Collapse>
                        }
                    </>
                }

                {/*** Product ************************* */}
                {useAuth.role() == 'admin' &&
                    <>
                        {/*<Box sx={ListSubheaderStyle}>ຂໍ້ມູນສິນຄ້າ ເເລະ ສາງສິນຄ້າ</Box>*/}
                        <ListItemButton
                            sx={{ height: '55px' }}
                            selected={props.menuStatus == 'small' && props.mainMenuActive === 'product'}
                            onClick={(e) => {
                                setOpen({ product: !open.product });
                                if (props.menuStatus == 'small') {
                                    handleClick(e, 'product');
                                }
                            }}
                        >
                            <ListItemIcon sx={imgPosition}>
                                <ListAltIcon sx={IconSize(props.menuStatus)} />
                            </ListItemIcon>
                            <ListItemText primary={props.menuStatus != 'small' ? "ຂໍ້ມູນສິນຄ້າ" : ""} sx={menuIconAndText} />
                            {props.menuStatus != 'small' ? open.product ? <ExpandLess /> : <ExpandMore /> : ''}
                            {props.menuStatus == 'small' ? <ArrowDropDownIcon sx={miniSubMenuIcon} /> : ''}
                        </ListItemButton>
                        {props.menuStatus != 'small' &&
                            <Collapse in={open.product} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {
                                        product.map((text, index) => (
                                            (text.package) &&
                                            <ListItemButton
                                                sx={subMenuStyle}
                                                key={text.link_name}
                                                component={NavLink}
                                                to={text.path}
                                                onClick={props.setOnMenuClose}
                                                selected={location.pathname === text.path || menuActive === text.path}
                                            >
                                                {/*
                                                <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                                    <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                                </Tooltip>
                                                */}
                                                <ListItemText sx={leftReszieHide}>
                                                    {(() => {
                                                        if (props.menuStatus != 'small') {
                                                            return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                                        } else {
                                                            return (<>&nbsp;</>)
                                                        }
                                                    })()}
                                                </ListItemText>
                                            </ListItemButton>
                                        ))
                                    }
                                </List >
                            </Collapse>
                        }
                    </>
                }

                {/*** customer */}
                {(useAuth.package(['PK00', 'PK01', 'PK02', 'PK03']) && (useAuth.role() == 'admin')) &&
                    <>
                        {/*<Box sx={ListSubheaderStyle}>ຂາຍສິນຄ້າ</Box>*/}
                        {
                            customer.map((text, index) => (
                                <ListItemButton
                                    sx={ListItemStyle(props.menuStatus)}
                                    key={text.link_name}
                                    component={NavLink}
                                    to={text.path}
                                    onClick={props.setOnMenuClose}
                                    selected={location.pathname === text.path || menuActive === text.path}
                                >
                                    <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                        <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                    </Tooltip>
                                    <ListItemText sx={iconAndText}>
                                        {(() => {
                                            if (props.menuStatus != 'small') {
                                                return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                            } else {
                                                return (<>&nbsp;</>)
                                            }
                                        })()}

                                    </ListItemText>
                                </ListItemButton>
                            ))
                        }
                    </ >
                }

                {/*** User*/}
                <>
                    <ListItemButton
                        sx={{ height: '55px' }}
                        selected={props.menuStatus == 'small' && props.mainMenuActive === 'user'}
                        onClick={(e) => {
                            setOpen({ user: !open.user });
                            if (props.menuStatus == 'small') {
                                handleClick(e, 'user');
                            }
                        }}
                    >
                        <ListItemIcon sx={imgPosition}>
                            <AccountCircleIcon sx={IconSize(props.menuStatus)} />
                        </ListItemIcon>
                        <ListItemText primary={props.menuStatus != 'small' ? "ຂໍ້ມູນຜູ້ໃຊ້ລະບົບ" : ""} sx={menuIconAndText} />
                        {props.menuStatus != 'small' ? open.user ? <ExpandLess /> : <ExpandMore /> : ''}
                        {props.menuStatus == 'small' ? <ArrowDropDownIcon sx={miniSubMenuIcon} /> : ''}
                    </ListItemButton>
                    {props.menuStatus != 'small' &&
                        <Collapse in={open.user} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {
                                    User.map((text, index) => (
                                        (text.package) &&
                                        <ListItemButton
                                            sx={subMenuStyle}
                                            key={text.link_name}
                                            component={NavLink}
                                            to={text.path}
                                            onClick={props.setOnMenuClose}
                                            selected={location.pathname === text.path || menuActive === text.path}
                                        >
                                            {/*
                                            <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                                <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                            </Tooltip>
                                            */}
                                            <ListItemText sx={leftReszieHide}>
                                                {(() => {
                                                    if (props.menuStatus != 'small') {
                                                        return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                                    } else {
                                                        return (<>&nbsp;</>)
                                                    }
                                                })()}
                                            </ListItemText>
                                        </ListItemButton>
                                    ))
                                }
                            </List >
                        </Collapse>
                    }
                </>

                {/*** General setting*/}
                {useAuth.role() == 'admin' &&
                    <>
                        {
                            GeneralSetting.map((text, index) => (
                                <ListItemButton
                                    sx={ListItemStyle(props.menuStatus)}
                                    key={text.link_name}
                                    component={NavLink}
                                    to={text.path}
                                    onClick={props.setOnMenuClose}
                                    selected={location.pathname === text.path || menuActive === text.path}
                                >
                                    <Tooltip title={(props.menuStatus != 'small') ? '' : text.link_name} placement='right' arrow>
                                        <ListItemIcon sx={ListItemIconStyle}>{text.icon}</ListItemIcon>
                                    </Tooltip>
                                    <ListItemText sx={iconAndText}>
                                        {(() => {
                                            if (props.menuStatus != 'small') {
                                                return (<label className='font14 cursor-pointer'>{text.link_name}</label>)
                                            } else {
                                                return (<>&nbsp;</>)
                                            }
                                        })()}
                                    </ListItemText>
                                </ListItemButton>
                            ))
                        }
                    </>
                }
            </Box >
        </>
    )

}

export default Leftmenu